// extracted by mini-css-extract-plugin
module.exports = {"list":"SocialLinks_list__TKkbZ","item":"SocialLinks_item__S7bWQ","is_circleBackground":"SocialLinks_is_circleBackground__DHog6","link":"SocialLinks_link__4rjus"};